/*
Copyright 2026 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import OrgSettings from '@/components/controllers/organization/OrgSettings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div className="flex flex-col grow">
    <OrgSettings />
  </div>
}
